<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getBtnDetails } from "@/api/auth/button";

import cTable from "@/base/common/index";
export default {
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
    },
  },
  data() {
    return {
      methods: {
        list: (p) => {
          p.id = this.config.rows.id;
          return getBtnDetails(p);
        },
        beforeHandleList({ data }) {
          return data;
        },
      },
      config: {
        height: 630,
        showOverflow: false,
        rowId: "id",
        slot: "div",
        rows: this.rows,
        resize: false,
      },
      footer: {
        show: () => false,
      },
      modals: {},
      header: {
        config: {
          custom: false,
        },
      },
      fields: [
        {
          name: () => this.$t("role_t"),
          key: "title",
          align: "left",
          width: 120,
        },
        {
          name: () => this.$t("accountNum"),
          key: "children",
          align: "left",
          render: (h, { row }) => {
            if (row.children.length > 0) {
              return h("div", [
                row.children.map((item) => {
                  return h(
                    "Tag",
                    {
                      props: {
                        type: "dot",
                        color: "primary",
                      },
                    },
                    item.account
                  );
                }),
              ]);
            }
          },
        },
      ],
    };
  },
};
</script>
